import { render, staticRenderFns } from "./GroupJoinButton.vue?vue&type=template&id=2da86726&"
import script from "./GroupJoinButton.vue?vue&type=script&lang=js&"
export * from "./GroupJoinButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports